// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".shadow[data-v-1830aa16] {\n  z-index: 99;\n  opacity: 0.6;\n  pointer-events: none;\n}\n", ""]);
// Exports
module.exports = exports;
